export default __webpack_public_path__ + "static/media/sundayMorning.49d56c28.png";